// extracted by mini-css-extract-plugin
export var tosLink = "_61-0";